module.exports = __webpack_public_path__ + "cf62783152e8aa0e80ab347104c30b14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-state/my-shelf.png
// module id = 1590
// module chunks = 0